/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Faq_2_AInputs */

const en_b2b_faq_2_a = /** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you use Stripe Connect (BYOS), you are the Merchant of Record. The funds settle directly into your bank account, and Stripe handles your tax documentation. We simply collect a platform fee.`)
};

const es_b2b_faq_2_a = /** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si usas Stripe Connect (BYOS), tú eres el Comerciante Registrado. Los fondos se liquidan directamente en tu cuenta bancaria y Stripe maneja tu documentación fiscal. Nosotros solo cobramos una tarifa de plataforma.`)
};

const fr_b2b_faq_2_a = /** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si vous utilisez Stripe Connect (BYOS), vous êtes le Marchand de référence. Les fonds sont versés directement sur votre compte bancaire, et Stripe gère votre documentation fiscale. Nous ne percevons qu'une commission de plateforme.`)
};

const de_b2b_faq_2_a = /** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du Stripe Connect (BYOS) nutzt, bist du der Merchant of Record. Das Geld geht direkt auf dein Bankkonto, und Stripe kümmert sich um die Steuerdokumentation.`)
};

const id_b2b_faq_2_a = /** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika Anda menggunakan Stripe Connect (BYOS), Anda adalah Merchant of Record. Dana dicairkan langsung ke rekening bank Anda, dan Stripe menangani dokumentasi pajak Anda. Kami hanya memungut biaya platform.`)
};

/** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */
const ja_b2b_faq_2_a = en_b2b_faq_2_a;

/** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */
const zh_b2b_faq_2_a = en_b2b_faq_2_a;

/** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */
const ar_b2b_faq_2_a = en_b2b_faq_2_a;

/** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */
const it_b2b_faq_2_a = en_b2b_faq_2_a;

/** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */
const ru_b2b_faq_2_a = en_b2b_faq_2_a;

/** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */
const pt_b2b_faq_2_a = en_b2b_faq_2_a;

/** @type {(inputs: B2b_Faq_2_AInputs) => LocalizedString} */
const ko_b2b_faq_2_a = en_b2b_faq_2_a;

/**
* | output |
* | --- |
* | "If you use Stripe Connect (BYOS), you are the Merchant of Record. The funds settle directly into your bank account, and Stripe handles your tax documentation..." |
*
* @param {B2b_Faq_2_AInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_faq_2_a = /** @type {((inputs?: B2b_Faq_2_AInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Faq_2_AInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_faq_2_a(inputs)
	if (locale === "es") return es_b2b_faq_2_a(inputs)
	if (locale === "fr") return fr_b2b_faq_2_a(inputs)
	if (locale === "de") return de_b2b_faq_2_a(inputs)
	if (locale === "ja") return ja_b2b_faq_2_a(inputs)
	if (locale === "zh") return zh_b2b_faq_2_a(inputs)
	if (locale === "ar") return ar_b2b_faq_2_a(inputs)
	if (locale === "id") return id_b2b_faq_2_a(inputs)
	if (locale === "it") return it_b2b_faq_2_a(inputs)
	if (locale === "ru") return ru_b2b_faq_2_a(inputs)
	if (locale === "pt") return pt_b2b_faq_2_a(inputs)
	return ko_b2b_faq_2_a(inputs)
});